import React, { Component } from 'react';
import { Container } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { Route, Routes, Navigate } from 'react-router-dom';
import Loadable from 'react-loadable';
import LoadingComponent from './LoadingComponent';
import { openModal } from '../../features/modals/modalActions';
// import ReactGA from 'react-ga';

const AsyncHomePage = Loadable({
  loader: () => import('../../features/home/HomePage'),
  loading: LoadingComponent
});
const AsyncUserAgreement = Loadable({
  loader: () => import('../../features/home/HomePage'),
  loading: LoadingComponent
});
const AsyncPostDashboard = Loadable({
  loader: () => import('../../features/post/PostDashboard/PostDashboard'),
  loading: LoadingComponent
});
const AsyncNavBar = Loadable({
  loader: () => import('../../features/nav/NavBar/NavBar'),
  loading: LoadingComponent
});
const AsyncPostForm = Loadable({
  loader: () => import('../../features/post/PostForm/PostForm'),
  loading: LoadingComponent
});
const AsyncFollowForm = Loadable({
  loader: () => import('../../features/user/FollowForm/FollowForm'),
  loading: LoadingComponent
});
const AsyncSettingsDashboard = Loadable({
  loader: () => import('../../features/user/Settings/SettingsDashboard'),
  loading: LoadingComponent
});
const AsyncRequestForm = Loadable({
  loader: () => import('../../features/request/RequestForm/RequestForm'),
  loading: LoadingComponent
});
const AsyncAdminDashboard = Loadable({
  loader: () => import('../../features/admin/AdminDashboard'),
  loading: LoadingComponent
});
const AsyncUserDetailedPage = Loadable({
  loader: () => import('../../features/user/UserDetailed/UserDetailedPage'),
  loading: LoadingComponent
});
const AsyncPeopleDashboard = Loadable({
  loader: () => import('../../features/user/PeopleDashboard/PeopleDashboard'),
  loading: LoadingComponent
});
const AsyncModalManager = Loadable({
  loader: () => import('../../features/modals/ModalManager'),
  loading: LoadingComponent
});
const AsyncErrorPermission = Loadable({
  loader: () => import('../../app/layout/ErrorPermission'),
  loading: LoadingComponent
});
const AsyncConfirmEmail = Loadable({
  loader: () => import('../../app/layout/ConfirmEmail'),
  loading: LoadingComponent
});
const AsyncNotFound = Loadable({
  loader: () => import('../../app/layout/NotFound'),
  loading: LoadingComponent
});

// Wrapper component for routes with navbar
const LayoutWrapper = ({ children }) => (
  <div>
    <AsyncNavBar />
    <Container className="main">
      {children}
    </Container>
  </div>
);

// Protected Route component for authenticated routes
const ProtectedRoute = connect(
  (state) => ({
    auth: state.firebase.auth,
    profile: state.firebase.profile
  }),
  { openModal }
)(({ children, auth, openModal }) => {
  if (!auth.isLoaded) {
    return <LoadingComponent />;
  }
  
  if (auth.isEmpty || !auth.emailVerified) {
    openModal('UnauthModal');
    return <Navigate to="/" replace />;
  }
  
  return children;
});

class App extends Component {
  render() {
    return (
      <div>
        <AsyncModalManager />
        <Routes>
          <Route path="/" element={<AsyncHomePage />} />
          <Route path="/user-agreement" element={<AsyncUserAgreement />} />
          <Route path="/posts/public" element={<LayoutWrapper><AsyncPostDashboard /></LayoutWrapper>} />
          <Route path="/posts/feed" element={<LayoutWrapper><ProtectedRoute><AsyncPostDashboard /></ProtectedRoute></LayoutWrapper>} />
          <Route path="/posts/own" element={<LayoutWrapper><ProtectedRoute><AsyncPostDashboard /></ProtectedRoute></LayoutWrapper>} />
          <Route path="/posts/saved" element={<LayoutWrapper><ProtectedRoute><AsyncPostDashboard /></ProtectedRoute></LayoutWrapper>} />
          <Route path="/posts/new" element={<LayoutWrapper><ProtectedRoute><AsyncPostForm /></ProtectedRoute></LayoutWrapper>} />
          <Route path="/posts/create" element={<Navigate to="/posts/new" replace />} />
          <Route path="/posts/add" element={<Navigate to="/posts/new" replace />} />
          <Route path="/posts/" element={<Navigate to="/posts/feed" replace />} />
          <Route path="/follow/new" element={<LayoutWrapper><ProtectedRoute><AsyncFollowForm /></ProtectedRoute></LayoutWrapper>} />
          <Route path="/requests/new" element={<LayoutWrapper><ProtectedRoute><AsyncRequestForm /></ProtectedRoute></LayoutWrapper>} />
          <Route path="/requests/" element={<Navigate to="/requests/new" replace />} />
          <Route path="/admin/*" element={<LayoutWrapper><ProtectedRoute><AsyncAdminDashboard /></ProtectedRoute></LayoutWrapper>} />
          <Route path="/follows" element={<LayoutWrapper><ProtectedRoute><AsyncPeopleDashboard /></ProtectedRoute></LayoutWrapper>} />
          <Route path="/profile/:id" element={<LayoutWrapper><ProtectedRoute><AsyncUserDetailedPage /></ProtectedRoute></LayoutWrapper>} />
          <Route path="/settings/*" element={<LayoutWrapper><ProtectedRoute><AsyncSettingsDashboard /></ProtectedRoute></LayoutWrapper>} />
          <Route path="/error-permission" element={<LayoutWrapper><AsyncErrorPermission /></LayoutWrapper>} />
          <Route path="/confirm-email" element={<LayoutWrapper><AsyncConfirmEmail /></LayoutWrapper>} />
          <Route path="/error" element={<LayoutWrapper><AsyncNotFound /></LayoutWrapper>} />
          <Route path="*" element={<LayoutWrapper><AsyncNotFound /></LayoutWrapper>} />
        </Routes>
      </div>
    );
  }
}

export default App;
